import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { StorageService } from '@resident-nx/shared';
import { KeycloakService } from '@resident-nx/web/data-access';

export const AuthWebGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sessionStorage = inject(StorageService);
  const keycloakService = inject(KeycloakService);

  sessionStorage.setItem('path-after-auth', {
    pathAfterAuth: state.url.split('?')[0],
    queryParams: route.queryParams,
  });

  return keycloakService.token ? true : new RedirectCommand(router.parseUrl('login'));
};
